import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { OPERATOR_HELP_PORTAL } from "@/lib/operator-help";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/operator/help/")({
  component: OperatorHelpIndex,
});

function OperatorHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the operator portal"
        className="mb-6"
      />
      <HelpCatalog
        search={search}
        onSearchChange={setSearch}
        catalog={OPERATOR_HELP_PORTAL}
      />
    </div>
  );
}
